<template>
    <div class="widget-alignment-content-field">
        <div class="w-full mb-3">
            <RedesignFormLabel
                :label="String($t('widget.innerAlignment'))"
                class="mb-2"
            />
            <RedesignRadioGroup
                v-model="localContentModel"
                class="radio-groups"
            >
                <RedesignRadioButton
                    label="start"
                    name="start"
                >
                    <redesign-base-icon
                        name="AlignLeft"
                        :size="24"
                    />
                </RedesignRadioButton>
                <RedesignRadioButton
                    label="center"
                    name="center"
                >
                    <redesign-base-icon
                        name="AlignCenter"
                        :size="24"
                    />
                </RedesignRadioButton>
                <RedesignRadioButton
                    label="end"
                    name="end"
                >
                    <redesign-base-icon
                        name="AlignRight"
                        :size="24"
                    />
                </RedesignRadioButton>
            </RedesignRadioGroup>
        </div>

        <div class="w-full mb-3 space-y-2">
            <RedesignFormLabel
                :label="String($t('widget.innerLayout'))"
                class="mb-1"
            />
            <RedesignRadioGroup
                v-model="localLayoutModel"
                class="radio-groups"
            >
                <RedesignRadio
                    :label="COUNTER_CARD_LAYOUT_DEFAULT_VALUE"
                >
                    {{ $t('widget.innerLayout.default') }}
                </RedesignRadio>
            </RedesignRadioGroup>
            <RedesignRadioGroup
                v-model="localLayoutModel"
                class="radio-groups"
            >
                <RedesignRadio
                    :label="COUNTER_CARD_LAYOUT_COLUMNS_VALUE"
                >
                    {{ $t('widget.innerLayout.columns') }}
                </RedesignRadio>
            </RedesignRadioGroup>
            <RedesignRadioGroup
                v-if="!simpleLayoutOptions"
                v-model="localLayoutModel"
                class="radio-groups"
            >
                <RedesignRadio
                    :label="COUNTER_CARD_LAYOUT_TITLE_ICON_VALUE"
                >
                    {{ $t('widget.innerLayout.twoRowsTitle') }}
                </RedesignRadio>
            </RedesignRadioGroup>
            <RedesignRadioGroup
                v-if="!simpleLayoutOptions"
                v-model="localLayoutModel"
                class="radio-groups"
            >
                <RedesignRadio
                    :label="COUNTER_CARD_LAYOUT_TITLE_VALUE_VALUE"
                >
                    {{ $t('widget.innerLayout.twoRowsValue') }}
                </RedesignRadio>
            </RedesignRadioGroup>
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import RedesignRadioButton from '@/components/RedesignBaseComponents/Inputs/RedesignRadioButton.vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { useVModel } from '@vueuse/core'
import RedesignRadio from '@/components/RedesignBaseComponents/Inputs/RedesignRadio.vue'
import {
    COUNTER_CARD_LAYOUT_COLUMNS_VALUE,
    COUNTER_CARD_LAYOUT_DEFAULT_VALUE,
    COUNTER_CARD_LAYOUT_TITLE_ICON_VALUE,
    COUNTER_CARD_LAYOUT_TITLE_VALUE_VALUE
} from '@/enum/default-layout-config'

const props = withDefaults(
    defineProps<{
        content: string
        layout: string
        simpleLayoutOptions?: boolean
    }>(),
    {
        content: 'center',
        layout: 'default',
        simpleLayoutOptions: false,
    }
)
const emit = defineEmits<{
    (e: 'update:content', pl: string): void
    (e: 'update:layout', pl: string): void
}>()

const localContentModel = useVModel(props, 'content', emit, { eventName: 'update:content' })
const localLayoutModel = useVModel(props, 'layout', emit, { eventName: 'update:layout' })
</script>
